import { cx } from '@cartly/ui';

type Variant = 'logo' | 'wordmark' | 'mark';

const SIZES: Record<Variant, { width: number; height: number }> = {
  logo: { width: 420, height: 88 },
  wordmark: { width: 192, height: 40 },
  mark: { width: 43, height: 32 },
};

/**
 * Cartly360 brand image.
 *  - surface="dark": always the light-text version (charcoal sidebar, dark panels).
 *  - surface="theme": follows the light/dark theme of the page.
 */
export function Logo({
  variant = 'logo',
  surface = 'theme',
  className,
}: {
  variant?: Variant;
  surface?: 'dark' | 'theme';
  className?: string;
}) {
  const { width, height } = SIZES[variant];
  const src = (dark: boolean) => `/brand/cartly360-${variant}${dark ? '-on-dark' : ''}.png`;
  if (surface === 'dark') {
    return (
      <img
        className={cx('brand-logo', `brand-logo--${variant}`, className)}
        src={src(true)}
        width={width}
        height={height}
        alt="Cartly360"
      />
    );
  }
  return (
    <span className={cx('brand-logo', `brand-logo--${variant}`, className)}>
      <img
        className="brand-logo__light"
        src={src(false)}
        width={width}
        height={height}
        alt="Cartly360"
      />
      <img
        className="brand-logo__dark"
        src={src(true)}
        width={width}
        height={height}
        alt=""
        aria-hidden="true"
      />
    </span>
  );
}
